/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon16Solid = forwardRef('WarningTriangleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.906 1.18c.954-1.57 3.234-1.57 4.188 0l5.539 9.098C16.625 11.91 15.449 14 13.539 14H2.46C.55 14-.625 11.91.367 10.278l5.54-9.098ZM9.127 11a1.127 1.127 0 1 1-2.254 0 1.127 1.127 0 0 1 2.254 0ZM9 4.5a1 1 0 0 0-2 0v3.25a1 1 0 1 0 2 0V4.5Z" })));
});
